<article id="app-news-list" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 place-items-center sm:place-items-stretch">
  @for (item of newsList(); track item.uuid; let i = $index) {
  <article class="home-news" [ngClass]="{ 'home-news__first': i === 0 }">

    <div class="home-news__body">
      <h2 [class.home-news__first_title]="i === 0" [class.home-news__title]="i !== 0">
        {{ item.title }}
      </h2>
      <p [class.home-news__first_desc]="i === 0" [class.home-news__desc]="i !== 0">
        {{ item.shortText }}
      </p>

      <button [class.home-news__first__button]="i === 0" [class.home-news__button]="i !== 0"
        (click)="openNewInfo(item.uuid)">
        {{ 'home.read' | translate }}
        <img *ngIf="i === 0" src="/images/icons/arrows/right-up-white.svg" alt="arrow" class="w-4 h-4" />
        <img *ngIf="i !== 0" src="/images/icons/arrows/right-up-black.svg" alt="arrow" class="w-4 h-4" />
      </button>
    </div>
  </article>
  }
</article>
